export default "__VITE_ASSET__CqPFNWhb__"